<template>
  <div id="app">
    <div class="layout">
      <!-- 蓝色导航栏 -->
      <header class="km-header" :class="{ scrolled: isScrolled }">
        <global-menu></global-menu>
      </header>

      <!-- 主体内容 -->
      <main class="main-content">
        <div v-if="isHomePage" class="home-view">
          <router-view />
        </div>
        <div v-else class="page-view k-container">
          <router-view />
        </div>
      </main>

      <!-- 页脚 -->
      <global-footer></global-footer>
    </div>
  </div>
</template>

<script>
import GlobalMenu from '@/components/GlobalMenu/GlobalMenu';
import GlobalFooter from '@/components/GlobalFooter/index';

export default {
  data() {
    return {
      isScrolled: false,
    };
  },
  components: {
    GlobalMenu,
    GlobalFooter,
  },
  computed: {
    isHomePage() {
      return this.$route && this.$route.path === '/';
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleScreenResize);
    this.handleScreenResize();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleScreenResize);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    handleScreenResize() {},
  },
};
</script>

<style lang="less" scoped>
#app {
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  height: 100%;
  min-height: 100vh;
  background: var(--bg-secondary);
}

.layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
}

/* 蓝色导航栏 */
.km-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: var(--primary);
  box-shadow: 0 2px 12px rgba(0, 86, 179, 0.2);
  transition: all 0.3s ease;

  &.scrolled {
    background: var(--primary-dark);
    box-shadow: 0 4px 20px rgba(0, 86, 179, 0.35);
  }
}

/* 主体内容 */
.main-content {
  flex: 1;
  margin-top: 68px;
  background: var(--bg-secondary);
  min-height: calc(100vh - 68px - 220px);
}

/* 内页包装器 */
.page-view {
  padding-top: 40px;
  padding-bottom: 60px;
}

.home-view {
  width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .main-content {
    margin-top: 60px;
  }
  .page-view {
    padding-top: 28px;
    padding-bottom: 40px;
  }
}

@media (max-width: 480px) {
  .main-content {
    margin-top: 56px;
  }
  .page-view {
    padding-top: 20px;
    padding-bottom: 32px;
  }
}
</style>
